module.exports = __webpack_public_path__ + "6817e3f4bdfda0f3f08a3dd90fe5011b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/sofas/sofa-pirate.png
// module id = 994
// module chunks = 0